import { motion } from 'framer-motion';
import { features } from '../data/features';
import { useLanguage } from '../i18n/LanguageContext';

export default function FeatureStrip() {
  const { t } = useLanguage();

  return (
    <section className="mx-auto max-w-6xl px-5 py-6">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5 }}
        className="grid grid-cols-2 overflow-hidden rounded-2xl border border-white/10 bg-navy-900/70 backdrop-blur-xl sm:grid-cols-3 lg:grid-cols-6 lg:divide-x lg:divide-white/10"
      >
        {features.map((feature) => {
          const Icon = feature.icon;
          return (
            <div
              key={feature.label.en}
              className="group flex items-center justify-center gap-2.5 px-4 py-4 text-center text-sm font-semibold text-slate-200 transition-colors hover:bg-white/5"
            >
              <Icon className="size-4.5 shrink-0 text-sky-400 transition-transform duration-300 group-hover:scale-115" />
              <span>{t(feature.label)}</span>
            </div>
          );
        })}
      </motion.div>
    </section>
  );
}
